import { useValidConditionValue } from 'features/config/useConfigConditionValue'
import AppConfig from 'config/AppConfig'
import { Platform } from 'react-native'

export type MeasurementMethod = 'sdk' | 'optical' | 'disabled'
export type MeasurementType = 'pd' | 'sh'

const MEASUREMENT_METHOD_CONDITION = 'measurement:method'

export const useMeasurementMethod = (
  type: MeasurementType
): MeasurementMethod => {
  const configuredMethods = useValidConditionValue(
    MEASUREMENT_METHOD_CONDITION,
    'measurementMethod'
  )
  console.log('configuredMethods', configuredMethods)

  if (Platform.OS !== 'ios') return 'disabled'

  const configuredMethod = configuredMethods?.[type]
  if (configuredMethod) return configuredMethod

  return AppConfig.isSdkEnabled ? 'sdk' : 'disabled'
}

/**
 * Which repeat press on the SH review sheet offers manual point adjustment
 * instead of another capture: 1 offers it on the first repeat, 2 after one
 * retry, and so on. 0 keeps it switched off.
 */
export const useShAdjustmentRetries = (): number => {
  const configuredMethods = useValidConditionValue(
    MEASUREMENT_METHOD_CONDITION,
    'measurementMethod'
  )

  return configuredMethods?.shAdjustmentRetries ?? 0
}
